export const priceLabel = (price, audience) =>
  (price || 0) > 0 ? `${price} Ft${audience === "together" ? "/fő" : ""}` : "Ingyenes";
